namespace TabAurous.Administration {
    export interface CampaignSetupForm {
        Code: Serenity.StringEditor;
        Type: Serenity.LookupEditor;
        Provider: Serenity.LookupEditor;
        AppId: Serenity.StringEditor;
        ApiKey: Serenity.StringEditor;
        Token: Serenity.StringEditor;
        UserName: Serenity.StringEditor;
        Password: Serenity.PasswordEditor;
    }

    export class CampaignSetupForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.CampaignSetup';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CampaignSetupForm.init)  {
                CampaignSetupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.PasswordEditor;

                Q.initFormType(CampaignSetupForm, [
                    'Code', w0,
                    'Type', w1,
                    'Provider', w1,
                    'AppId', w0,
                    'ApiKey', w0,
                    'Token', w0,
                    'UserName', w0,
                    'Password', w2
                ]);
            }
        }
    }
}
